import { v4 as uuidv4 } from "uuid";
export class EntryModel {
    constructor() {
        this.id = uuidv4();
        this.referenceNumber = "";
        this.description = "";
        this.state = "";
        this.type = "";
        this.categories = [];
        this.upcomingEvents = "";
        this.tags = [];
        this.status = "";
        this.mostRecentAction = "";
        this.isFavorite = false;
        this.isEntryDeletable = false;
        this.isEntryEditable = false;
        this.referenceLink = "";
        this.whyItMatters = "";
        this.actionDateAsString = "";
    }
}
export default class Entry extends EntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
